import { ASSETS, NIGHT_VISION } from "@/data/content";
import { t } from "@/data/texts";
import { img } from "@/data/images";
import { Reveal } from "@/components/effects/Effects";

export default function NightVision() {
  return (
    <section
      id="nocni-videni"
      className="relative bg-black border-b border-white/10 overflow-hidden"
      data-testid="night-vision-section"
    >
      <div className="scanlines absolute inset-0 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-5 py-20 lg:py-28 grid lg:grid-cols-2 gap-14 items-center relative z-10">
        <Reveal>
          <p className="text-xs tracking-[0.4em] text-nv uppercase mb-4">{NIGHT_VISION.kicker}</p>
          <h2 className="font-head text-4xl sm:text-5xl text-nv mb-4 leading-none">70&thinsp;%</h2>
          <h3 className="font-head text-2xl sm:text-3xl text-neutral-100 mb-6">{t("nightvision.title", NIGHT_VISION.title)}</h3>
          <p className="text-base sm:text-lg text-neutral-400 leading-relaxed whitespace-pre-line">
            {t("nightvision.body", NIGHT_VISION.body)}
          </p>
        </Reveal>

        <Reveal delay={150}>
          <div className="relative">
            {/* IR crosshair frame */}
            <div className="relative border border-nv/40 overflow-hidden" style={{ boxShadow: "0 0 40px rgba(57,255,20,0.15)" }}>
              <img
                src={img("tablet", ASSETS.tablet)}
                alt="Tablet s nočním viděním"
                className="w-full h-[360px] sm:h-[460px] object-cover nv-green"
              />
              {/* HUD overlay */}
              <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-3 left-3 text-[10px] tracking-[0.3em] text-nv">● NV MODE — IR</div>
                <div className="absolute top-3 right-3 text-[10px] tracking-[0.3em] text-nv">REC 00:47:12</div>
                <div className="absolute bottom-3 left-3 text-[10px] tracking-[0.3em] text-nv">BAT 87%</div>
                {/* crosshair */}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                  <div className="w-24 h-24 border border-nv/50 rounded-full" />
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-px h-32 bg-nv/40" />
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-px w-32 bg-nv/40" />
                </div>
                {/* corner brackets */}
                <span className="absolute top-2 left-2 w-6 h-6 border-t-2 border-l-2 border-nv/60" />
                <span className="absolute top-2 right-2 w-6 h-6 border-t-2 border-r-2 border-nv/60" />
                <span className="absolute bottom-2 left-2 w-6 h-6 border-b-2 border-l-2 border-nv/60" />
                <span className="absolute bottom-2 right-2 w-6 h-6 border-b-2 border-r-2 border-nv/60" />
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
